module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alarm-center"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.onTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "namespace_abnormal_jobs"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v("异常作业\n            "), (_vm.countOfAlarmJobs.unnormal_job) ? _c('el-badge', {
    attrs: {
      "type": "danger",
      "value": _vm.countOfAlarmJobs.unnormal_job
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "namespace_timeout_jobs"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("超时作业\n            "), (_vm.countOfAlarmJobs.timeout_4_alarm_job) ? _c('el-badge', {
    attrs: {
      "type": "danger",
      "value": _vm.countOfAlarmJobs.timeout_4_alarm_job
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "namespace_failover_jobs"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("无法高可用作业\n            "), (_vm.countOfAlarmJobs.unable_failover_job) ? _c('el-badge', {
    attrs: {
      "type": "warning",
      "value": _vm.countOfAlarmJobs.timeout_4_alarm_job
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e0a7d00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_list/alarm/namespace_alarm_center.vue
// module id = 1375
// module chunks = 1